export const addZerosLeft = (originalNumber: number) =>
    `0000${originalNumber.toString()}`.slice(-4);
